module.exports = new __parcel__URL__("ContentWrapperSpotlightGIF-light.9900190e.gif").toString();